import SideBar from "../menu/SideBarMenu";
import React, { useEffect, useRef, useState } from "react";
import Tabs from "./Tabs";
import { HeaderProfile } from "./HeaderProfile";
import closeSideBar from "../../assets/collapse.png";
import openSideBar from "../../assets/expand.png";
import { useAppViewMode } from "hooks/useAppViewMode";
import { VIEW_MODES } from "CONSTANT/ViewModes/AppViewModes";
import { useLocation } from "react-router";

const Layout = () => {
    const [tabsopen] = useState(["Dashboard"]);
    const [showSettings, setShowSettings] = useState(false);
    const [backToSettings, setBackToSettings] = useState(false);
    const { appViewMode } = useAppViewMode();
    const [collapsed, setCollapse] = useState(false);
    const ref = useRef();
    const location = useLocation();
    const showMenu = appViewMode !== VIEW_MODES.OUTLOOK;

    useEffect(() => {
        setShowSettings(location.pathname.startsWith("/settings"));
    }, [location.pathname]);

    let toggleLeftside = () => {
        setCollapse(!collapsed);
        ref.current.toggleSidebar();
    };

    return (
        <div className="container-fluid p-0 bg-light">
            <div className="row vh-100 vw-100 flex-nowrap">
                {showMenu && !showSettings && (
                    <div
                        className={
                            "col p-0 pe-2 border-topright position-relative " +
                            (collapsed ? "leftside-collapsed" : "leftside-expanded")
                        }
                    >
                        <img
                            className={
                                "leftside-collapse-button " +
                                (collapsed
                                    ? "collapsed-button-location"
                                    : "expanded-button-location")
                            }
                            src={collapsed ? openSideBar : closeSideBar}
                            onClick={() => {
                                toggleLeftside();
                            }}
                            alt="Collapse Icon"
                        ></img>
                        <SideBar
                            ref={ref}
                            collapsedhaha={collapsed}
                            showSettings={() => {
                                setShowSettings(true);
                                setBackToSettings(!backToSettings);
                            }}
                            hideSettings={() => {
                                setShowSettings(false);
                            }}
                        ></SideBar>
                    </div>
                )}
                <div className="col h-100 w-100 p-0 overflow-hidden">
                    <Tabs
                        className="h-100 w-100"
                        showSettings={showSettings}
                        viewmode={appViewMode}
                    />

                    {!showSettings && <HeaderProfile tabsopen={tabsopen} />}
                </div>
            </div>
        </div>
    );
};

export default Layout;
